"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDialogClose = void 0;
async function handleDialogClose(payload, dialogRef) {
    if (dialogRef.current) {
        dialogRef.current.close();
        dialogRef.current = null;
    }
}
exports.handleDialogClose = handleDialogClose;
